<template>
  <div :class="nsArr" :style="style">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useNamespace } from '@xzx-design/hooks'
import { textProps } from './text'
import type { CSSProperties } from 'vue'

defineOptions({
  name: 'XzxText',
})

const props = defineProps(textProps)
const ns = useNamespace('text')

const nsArr = computed(() => [
  ns.b(),
  ns.m(props.type),
  ns.m(props.display),
  props.weight && ns.m(`${props.weight}-w`),
  props.size && ns.m(`${props.size}-s`),
])

const style = computed<CSSProperties>(() => ({
  color: props.color,
  textAlign: props.textAlign as 'left' | 'right' | 'center' | 'justify',
  display: props.display,
  ...ellipsis.value,
}))

const ellipsis = computed<CSSProperties>(() =>
  props?.ellipsis > 0
    ? {
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineClamp: props.ellipsis,
        boxOrient: 'vertical',
      }
    : {}
)
</script>
